type PaymentMethods = {
  achAccountNumberLast4: string;
  achAuthorized: boolean;
  blockedBilling: boolean;
  billingFrequency: number;
  paymentCurrency: string;
  paymentThreshold: number;
  paymentType: string;
  stripeAchSet: boolean;
  stripeAuthorized: boolean;
  stripeCcBrand: string;
  stripeCcExpMonth: number;
  stripeCcExpYear: number;
  stripeCcLast4: number;
  stripeCreditCardSet: boolean;
  stripePublishableKey: string;
  stripeToken: string;
};

export type PaymentMethodsJson = {
  ach_account_number: string;
  ach_authorized: boolean;
  blocked_billing: boolean;
  billing_frequency: number;
  payment_currency: string;
  payment_threshold: number;
  payment_type: string;
  stripe_ach_set: boolean;
  stripe_authorized: boolean;
  stripe_cc_brand: string;
  stripe_cc_exp_month: number;
  stripe_cc_exp_year: number;
  stripe_cc_last4: number;
  stripe_credit_card_set: boolean;
  stripe_publishable_key: string;
  stripe_token: string;
};

export enum PaymentMethodType {
  BankAccount = 'ACH',
  CreditCard = 'STRIPE',
}

export type ChangePaymentMethodPayload = {
  action: {
    type: string;
    payment_method: {
      type: string;
    };
    is_impersonate: boolean;
    tracker_sessionid: string;
  };
};

export const fromJSON = (data: PaymentMethodsJson): PaymentMethods => {
  return {
    achAccountNumberLast4: data.ach_account_number,
    achAuthorized: data.ach_authorized,
    blockedBilling: data.blocked_billing,
    billingFrequency: data.billing_frequency,
    paymentCurrency: data.payment_currency,
    paymentThreshold: data.payment_threshold,
    paymentType: data.payment_type,
    stripeAchSet: data.stripe_ach_set,
    stripeAuthorized: data.stripe_authorized,
    stripeCcBrand: data.stripe_cc_brand,
    stripeCcExpMonth: data.stripe_cc_exp_month,
    stripeCcExpYear: data.stripe_cc_exp_year,
    stripeCcLast4: data.stripe_cc_last4,
    stripeCreditCardSet: data.stripe_credit_card_set,
    stripePublishableKey: data.stripe_publishable_key,
    stripeToken: data.stripe_token,
  };
};

export const toJSON = (data: PaymentMethods): PaymentMethodsJson => {
  return {
    ach_account_number: data.achAccountNumberLast4,
    ach_authorized: data.achAuthorized,
    blocked_billing: data.blockedBilling,
    billing_frequency: data.billingFrequency,
    payment_currency: data.paymentCurrency,
    payment_threshold: data.paymentThreshold,
    payment_type: data.paymentType,
    stripe_ach_set: data.stripeAchSet,
    stripe_authorized: data.stripeAuthorized,
    stripe_cc_brand: data.stripeCcBrand,
    stripe_cc_exp_month: data.stripeCcExpMonth,
    stripe_cc_exp_year: data.stripeCcExpYear,
    stripe_cc_last4: data.stripeCcLast4,
    stripe_credit_card_set: data.stripeCreditCardSet,
    stripe_publishable_key: data.stripePublishableKey,
    stripe_token: data.stripeToken,
  };
};

export default PaymentMethods;
